module.exports = __webpack_public_path__ + "static/media/ic-paperclip.3fab8c07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-paperclip.svg
// module id = 861
// module chunks = 1